import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { deepClone } from './utils'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/404'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title, to.path)

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasUID = store.getters.uid && store.getters.uid !== 0
      if (hasUID) {
        next()
      } else {
        try {
        // get user info
          const data = await store.dispatch('user/getInfo')
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', data)

          // 刷新后添加动态路由
          let orderRouter = localStorage.getItem('orderRouter')
          if (orderRouter) {
            orderRouter = JSON.parse(orderRouter)
            if (store.getters.token === orderRouter.token) {
              accessRoutes.forEach((element) => {
                if (element.path === orderRouter.fullPath) {
                  let router = {}
                  element.children.forEach((item) => {
                    if (item.path === orderRouter.path.replace(/\d/g, '') && item.name === orderRouter.name.replace(/\d/g, '')) {
                      router = deepClone(item)
                      router.name = orderRouter.name
                      router.path = orderRouter.path
                      router.meta.title = orderRouter.title
                      router.hidden = true
                      element.children.push(router)
                    }
                  })
                }
              })
            } else {
              localStorage.removeItem('orderRouter')
            }
          }
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
